;; ($ => {
	const setVariable = () => {
		for (const item of $.querySelectorAll('.product-item')) {
			Object.assign(item, { m: 0, h: 100, t: item.querySelector('.product-item__thumbnail img') });

			if (item.t !== null) {
				item.t.onload = () => {
					item.m = +window.getComputedStyle(item).paddingTop.replace('px', '');

					const icon = item.querySelector('.ranking-mark');
					if (icon !== null) {
						const s = window.getComputedStyle(icon);
						if (+s.width.replace('px', '') !== NaN) {
							item.m += +s.width.replace('px', '') + +s.marginBottom.replace('px', '');
						}
					}

					item.h = item.t.clientHeight;

					item.style.cssText += `--grid-thumb-margin: ${item.m}px; --grid-thumb-height: ${item.h}px;`;
				};
			}
		}
	};

	// Insert Aspect ratio & padding
	for (const evt of ['load', 'resize']) window.addEventListener(evt, setVariable);

	// Check SFA method
	const is_check = () => {
		const flg = setTimeout(is_check, 100);
		if (window.AppFavoriteButton === undefined) {
			return;
		}
		if (window.AppFavoriteButton.cookie === undefined) {
			return;
		}

		clearTimeout(flg);

		const path = location.pathname.split('/').filter(Boolean);

		// Initialize Top page
		if (path.length === 0) {
			if (window.AppFavoriteButton.settings.setting === 'on' && +window.AppFavoriteButton.settings.show.top !== 1 && path.length === 0) {
				for (const item of $.querySelectorAll('.product-item')) {
					if (item.querySelector('._SFA') !== null) {
						continue;
					}

					item.style.position = 'relative';

					const handle = item.querySelector('a').href.split('/').slice(-1)[0];
					const container = Object.assign($.createElement('div'), { className: '_SFA collection' });
					container.dataset.id = handle;
					item.append(container);

					window.AppFavoriteButton.createButton(container, { bool: true, checked: window.AppFavoriteButton.cookie.fav_items.includes(handle) });
				}
			}
		}

		// Insert Aspect ratio, from favotite list page
		if (path.slice(-1)[0] === 'favorite-list') {
			$.querySelector('.template-page').classList.add('template-page-favorite-list');

			const target = $.querySelector('._SFB__list');
			const param = { subtree: true, childList: true };
			const observer = new MutationObserver(() => {
				observer.disconnect();

				for (const item of target.querySelectorAll('li')) {
					const thumb = item.querySelector('img');
					thumb.onload = () => {
						item.style.cssText += `--grid-thumb-margin: 0; --grid-thumb-height: ${thumb.height / thumb.width * 100}%;`;
					};
				}

				observer.observe(target, param);
			});
			observer.observe(target, param);
		}
	};
	is_check();
})(document);